export const messages = {
  "adjudication.biographyCheck": "Biographical check",
  "adjudication.faceCheck": "Face comparison",
  "adjudication.match": "Matched",
  "adjudication.noMatch": "Mismatch",
  "adjudication.unavailable": "Unavailable",
  "adjudication.correctionRequired": "This case requires corrected information or ONI evidence before it can be approved.",

  "adjudication.ninuMenu": "NINU applications",
  "adjudication.voterMenu": "Adjudication",
  "adjudication.ninuTitle": "NINU certificate applications",
  "adjudication.voterTitle": "Voter registration adjudication",
  "adjudication.listDescription": "Applications, evidence and decisions",
  "adjudication.refresh": "Refresh",
  "adjudication.search": "NINU or case number",
  "adjudication.statusLabel": "Status",
  "adjudication.allStatuses": "All statuses",
  "adjudication.cases": "cases",
  "adjudication.submittedAt": "Submitted",
  "adjudication.applicant": "Applicant",
  "adjudication.reasonLabel": "Reason",
  "adjudication.examine": "Review",
  "adjudication.empty": "No applications",
  "adjudication.previous": "Previous",
  "adjudication.next": "Next",
  "adjudication.noPhoto": "No photograph",
  "adjudication.dateOfBirth": "Date of birth",
  "adjudication.comparison": "Identity comparison",
  "adjudication.field": "Field",
  "adjudication.request": "Application",
  "adjudication.oni": "ONI record",
  "adjudication.caseTitle": "Case review",
  "adjudication.openVoterApplication": "Open voter application",
  "adjudication.approve": "Approve",
  "adjudication.reject": "Reject",
  "adjudication.decision": "Decision",
  "adjudication.reviewer": "Operator",
  "adjudication.back": "Back to applications",
  "adjudication.decisionExplanation": "A documented reason is required and will be recorded in the audit trail. Approving a voter case resumes the remaining verification stages.",
  "adjudication.decisionReason": "Decision justification",
  "adjudication.confirm": "Confirm",
  "adjudication.status.PENDING_REVIEW": "Pending review",
  "adjudication.status.APPROVED": "Approved",
  "adjudication.status.REJECTED": "Rejected",
  "adjudication.reason.BIOGRAPHICAL_MISMATCH": "Biographical mismatch",
  "adjudication.reason.BIOMETRIC_MISMATCH": "Face mismatch",
  "adjudication.reason.ONI_RECORD_MISSING": "ONI record missing",
  "adjudication.reason.ONI_PHOTO_MISSING": "ONI photo missing",
  "adjudication.reason.AUTOMATIC_MATCH": "Automatic match",
  "adjudication.reason.MANUAL_REVIEW": "Manual review",
  "adjudication.reason.INCOMPLETE_BIOGRAPHICAL_DATA": "Incomplete biographical data",
  "adjudication.reason.MISSING_VOTING_CENTER": "Voting centre missing",
  "adjudication.reason.MISSING_APPLICATION_PHOTO": "Application photo missing",
  "adjudication.field.firstName": "First name",
  "adjudication.field.lastName": "Last name",
  "adjudication.field.dateOfBirth": "Date of birth",

  "geo.redirect.menu": "Redirect",
  "geo.redirect.operation": "Operation",
  "geo.redirect.source": "Center to close",
  "geo.redirect.sourceHint": "Its voters will be reassigned",
  "geo.redirect.target": "Receiving center",
  "geo.redirect.targetHint": "The center that remains active",
  "geo.redirect.selected": "Selected",
  "geo.redirect.clear": "Clear selection",
  "geo.redirect.search": "Search center, code or place",
  "geo.redirect.department": "Department",
  "geo.redirect.allDepartments": "All departments",
  "geo.redirect.centerCount": "{count} centers",
  "geo.redirect.noResults": "No centers match your search.",
  "geo.redirect.noLocation": "Location not specified",
  "geo.redirect.previous": "Previous page",
  "geo.redirect.next": "Next page",
  "geo.redirect.swap": "Swap source and destination",
  "geo.redirect.preview": "Redirection preview",
  "geo.redirect.mergeEffect": "The receiving center survives; the source is disabled.",
  "geo.redirect.closeEffect": "The source is disabled and routed to the receiving center.",
  "geo.redirect.sourcePlaceholder": "Choose a source center",
  "geo.redirect.targetPlaceholder": "Choose a receiving center",
  "geo.redirect.nextSteps": "Existing voters: hourly transfer. New approvals: automatic redirection. Published rolls remain unchanged.",
  "geo.redirect.confirm": "Confirm redirection",
  "geo.redirect.saving": "Saving...",
  "geo.redirect.success": "Redirection registered",
  "geo.redirect.successDetail": "{voters} voters pending transfer; {applications} applications referencing the old center.",
  "geo.redirect.newOperation": "New redirection",
  "geo.redirect.invalidPrefill": "This center is not eligible as a redirection source.",
  "geo.redirect.reason.SAME_CENTER": "Cannot redirect a center to itself",
  "geo.redirect.reason.ALREADY_REDIRECTED": "Already redirected",
  "geo.redirect.reason.EXISTING_DESTINATION": "Already receiving other centers",
  "geo.redirect.reason.INVALID_STATUS": "Invalid center status",
  "geo.redirect.reason.NOT_ENABLED": "Destination is not enabled",
  "geo.redirect.reason.MISSING_SECTION": "Destination has no communal section",
  "operator.request.approve": "Approuver",
  "operator.request.reject": "Rejeter",
  "operator.request.loading": "Chargement…",
  "operator.request.reference": "Demande",
  "operator.request.fallbackName": "Demande de compte opérateur",
  "operator.request.identityHint": "Identité du demandeur",
  "operator.request.lifecycle": "Inscription",
  "operator.request.lifecycleHint": "Statut et dates de la demande",
  "operator.request.territory": "Affectation demandée",
  "operator.request.territoryHint": "Type d’opérateur et affectation géographique",
  "operator.request.assignmentWarning": "L’affectation géographique demandée est absente ou incohérente. Une demande en erreur peut néanmoins être approuvée.",
  "operator.request.decision": "Décision",
  "operator.request.decisionHint": "Décision du backoffice",
  "operator.request.decisionReason": "Motif",
  "operator.request.createdUser": "Compte opérateur créé",
  "operator.request.reviewer": "Réviseur backoffice",
  "operator.request.publicKey": "Clé publique de signature",
  "operator.request.publicKeyHint": "Clé publique fournie par le demandeur",
  "operator.request.publicKeyQr": "Code QR de la clé publique",
  "operator.request.status.ERROR": "Erreur",
  "operator.request.status.READY": "Prête",
  "operator.request.status.PENDING": "En attente",
  "operator.request.status.APPROVED": "Approuvée",
  "operator.request.status.REJECTED": "Rejetée",
  "operator.type": "Type d’opérateur",
  "operator.type.all": "Tous les types",
  "operator.type.CENTER": "CENTER",
  "operator.type.BEC": "BEC",
  "operator.type.BED": "BED",
  "operator.type.UNSPECIFIED": "Non précisé",
  "operator.scope": "Territoire d’affectation",
  "operator.scope.CENTER": "Centre de vote",
  "operator.scope.BEC": "Commune",
  "operator.scope.BED": "Département",
  "operator.scope.unassigned": "Affectation manquante ou incohérente",
  "operator.requests.title": "Demandes de comptes opérateurs",
  "operator.requests.subtitle": "Examiner les demandes CENTRE, BEC et BED selon le type d’opérateur et le territoire demandé.",
  "operator.request.invalidAssignment": "Le type d’opérateur ou le territoire demandé est invalide. Vous pouvez néanmoins approuver une demande en erreur.",
  "operator.request.notFound": "Demande de compte opérateur introuvable",
  "operator.account.notFound": "Compte opérateur introuvable",
  "maintenance.menu": "Maintenance",
  "maintenance.title": "Maintenance des demandes",
  "maintenance.description": "Suivi des demandes nécessitant une intervention et exécution des actions de maintenance.",
  "maintenance.applications": "Demandes à examiner",
  "maintenance.applicationsHint": "Demandes en erreur ou en examen manuel. Les actions dépendent de leur état.",
  "maintenance.allExceptions": "Toutes les anomalies",
  "maintenance.manualCheck": "Examen manuel",
  "maintenance.refresh": "Actualiser",
  "maintenance.details": "Diagnostic",
  "maintenance.oniAttempts": "Tentatives ONI : {count}",
  "maintenance.reprocess": "Retraiter",
  "maintenance.reprocessSelected": "Retraiter la sélection ({count})",
  "maintenance.reprocessAll": "Retraiter tous les examens manuels",
  "maintenance.selectPage": "Sélectionner les demandes en examen manuel de cette page",
  "maintenance.selectApplication": "Sélectionner la demande",
  "maintenance.searchPlaceholder": "Rechercher par nom, NINU ou numéro de reçu",
  "maintenance.confirmTitle": "Confirmer le retraitement",
  "maintenance.confirmAll": "Retraiter les {count} demandes actuellement en examen manuel ?",
  "maintenance.confirmSelected": "Retraiter ces {count} demandes sélectionnées ?",
  "maintenance.confirmExplanation": "Les demandes éligibles repasseront au statut Soumise et seront reprises par les traitements habituels. Les données et dates de soumission restent inchangées ; l’action est inscrite dans le journal de chaque demande.",
  "maintenance.reprocessedCount": "{count} demandes remises en traitement.",
  "maintenance.loadFailed": "Impossible de charger les demandes à examiner.",
  "maintenance.actionFailed": "Impossible de relancer le traitement.",
  "voter.applicationJournal": "Journal de la demande",
  "voter.applicationJournalSubtitle": "Actions de maintenance et corrections apportées à cette demande",
  "voter.noJournalEntries": "Aucune entrée dans le journal.",
  "voter.journal.performedBy": "Effectué par",
  "voter.journal.reprocessed": "Remise en traitement",
  "voter.journal.oniPhotoUsedForApproval": "Photo ONI utilisée pour l’approbation : demande soumise avant le 31 octobre 2026 sans portrait",
  "voter.journal.faceVerificationSkippedNoPhoto": "Vérification faciale ignorée : demande soumise avant le 31 octobre 2026 sans photo",
  "voter.journal.systemActor": "Système",
  "voter.reviewerBackofficeUserId": "Identifiant du réviseur backoffice",
  "voter.journal.manualAdjudication": "Envoyée en examen manuel",
  "voter.journal.reason": "Motif",
  "voter.journal.reason.MISSING_VOTING_CENTER": "Aucun centre de vote attribué",
  "voter.journal.reason.INCOMPLETE_BIOGRAPHICAL_DATA": "Informations biographiques obligatoires manquantes",
  "voter.journal.mismatchField": "Champ différent",
  "voter.journal.applicationValue": "Valeur de la demande",
  "voter.journal.identifiedPersonValue": "Valeur de la personne identifiée",
  "voter.journal.reason.BIOGRAPHICAL_MISMATCH": "Les données de la demande ne correspondent pas à la personne identifiée",
  "voter.journal.reason.MISSING_APPLICATION_PHOTO": "Photo de la demande manquante",
"app.menu.cep_records.label": "Dossiers des personnes",
"app.menu.cep_records.description": "Dossiers d’identité du CEP",

  "app.menu.voter_applications.label": "Demandes d’inscription électorale",
  "app.menu.voter_applications.description": "Demandes d’inscription sur les listes électorales",

  "app.menu.voters.label": "Registre électoral",
  "app.menu.voters.description": "Registres des électeurs inscrits",

  "app.menu.user_account_requests.label": "Demandes de comptes opérateurs",
  "app.menu.user_account_requests.description": "Demandes d’accès aux comptes opérateurs",
"app.menu.field_operators.label": "Opérateurs de terrain",
"app.menu.field_operators.description": "Comptes des opérateurs de terrain et demandes d’accès",
"app.menu.user_accounts.label": "Comptes",
"app.menu.user_accounts.description": "Comptes opérateurs de terrain",

  "app.menu.electoral_geography.label": "Géographie électorale",
  "app.menu.electoral_geography.description": "Centres de vote et géographie électorale",

  "app.menu.actions.list": "Liste",
  "app.menu.actions.new": "Nouveau",

  "table.search": "Rechercher",
  "table.noData": "Aucun enregistrement trouvé",
  "table.rowsPerPage": "Lignes par page",
  "table.of": "sur",

"common.latest": "Le plus récent",

  "Picture": "Photo",
  "Identifier": "Identifiant",
  "First name": "Prénom",
  "Last name": "Nom",
  "Date of birth": "Date de naissance",
  "Sex": "Sexe",
  "Primary contact": "Contact principal",
  "Primary address": "Adresse principale",
  "Photo": "Photo",
  "Actions": "Actions",
  "View": "Voir",
  "Users": "Utilisateurs",
  "menu.backoffice": "Backoffice",

  "Photo available": "Photo disponible",
    "app.menu.reporting.label": "Rapports",
    "app.menu.reporting.description": "Statistiques d’inscription et analyse géographique",
    "app.menu.reporting.overview": "Vue d’ensemble",
    "app.menu.reporting.advanced": "Analyse avancée",
    "Operator reports": "Opérateurs",

    "menu.voter.registration": "Inscription",
"menu.voter.applications": "Demandes",
"menu.voter.records": "Électeurs",
"Diagnostics": "Diagnostics",
"menu.api_users": "Utilisateurs API",

"app.menu.reporting.votingCenterReports": "Centres de vote",

    "app.menu.actions.manage": "Gérer",
    "common.account": "compte",
    "common.accountLower": "compte",
    "common.accountsLower": "comptes",
    "common.actions": "Actions",
    "common.active": "Actif",
    "common.add": "Ajouter",
    "common.address": "Adresse",
    "common.all": "Tous",
    "common.allSources": "Toutes les sources",
    "common.allStatuses": "Tous les statuts",
    "common.appVersion": "Version de l’application",
    "common.application": "Demande",
    "common.approved": "Approuvé",
    "common.archived": "Archivée",
    "common.area": "Zone",
    "common.cancel": "Annuler",
    "common.captured": "Capturé",
    "common.class": "Classe",
    "common.clearAll": "Tout effacer",
    "common.closeFilters": "Fermer les filtres",
    "common.code": "Code",
    "common.copy": "Copier",
    "common.day": "Jour",
    "common.default": "Par défaut",
    "common.deleted": "Supprimé",
    "common.description": "Description",
    "common.details": "Détails",
    "common.device": "Appareil",
    "common.deviceId": "ID de l’appareil",
    "common.disabled": "Désactivé",
    "common.done": "Terminé",
    "common.edit": "Modifier",
    "common.empty": "(vide)",
    "common.error": "Erreur",
    "common.event": "Événement",
    "common.filters": "Filtres",
    "common.first": "Premier",
    "common.format": "Format",
    "common.from": "Du",
    "common.generated": "Généré",
    "common.generating": "Génération...",
    "common.geography": "Géographie",
    "common.id": "ID",
    "common.identifier": "Identifiant",
    "common.interval": "Intervalle",
    "common.last": "Dernier",
    "common.level": "Niveau",
    "common.loading": "Chargement...",
    "common.loading.short": "Chargement",
    "common.localFile": "Fichier local",
    "common.message": "Message",
    "common.metric": "Indicateur",
    "common.month": "Mois",
    "common.name": "Nom",
    "common.next": "Suivant",
    "common.no": "Non",
    "common.noAddress": "(aucune adresse)",
    "common.noReceipt": "(aucun reçu)",
    "common.noResults": "Aucun résultat.",
    "common.notVerified": "Non vérifié",
    "common.nothingSelected": "Aucun élément sélectionné.",
    "common.objectKey": "Clé objet",
    "common.other": "Autre",
    "common.page": "page",
    "common.parent": "Parent",
    "common.pending": "En attente",
    "common.person": "Personne",
    "common.photo": "Photo",
    "common.picture": "Photo",
    "common.prev": "Préc.",
    "common.primary": "Principal",
    "common.ready": "Prêt",
    "common.rejected": "Rejeté",
    "common.remove": "Supprimer",
    "common.report": "Rapport",
    "common.reset": "Réinitialiser",
    "common.resetFilters": "Réinitialiser les filtres",
    "common.reviewed": "Examiné",
    "common.save": "Enregistrer",
    "common.saving": "Enregistrement...",
    "common.selectItemTree": "Sélectionnez un élément dans l’arborescence",
    "common.selectedItem": "Élément sélectionné",
    "common.shown": "affichés",
    "common.since": "depuis",
    "common.source": "Source",
    "common.splash": "écran d’accueil",
    "common.status": "Statut",
    "common.submitted": "Soumis",
    "common.summary": "Résumé",
    "common.tabletId": "ID de la tablette",
    "common.tags": "Étiquettes",
    "common.thread": "Thread",
    "common.time": "Heure",
    "common.to": "Au",
    "common.total": "Total",
    "common.type": "Type",
    "common.unknown": "Inconnu",
    "common.unnamed": "Sans nom",
    "common.updatingCounts": "Mise à jour des décomptes...",
    "common.user": "Utilisateur",
    "common.verifiedAt": "Vérifié le",
    "common.version": "Version",
    "common.view": "Voir",
    "common.viewSection": "Voir la section",
    "common.week": "Semaine",
    "common.yes": "Oui",
    "diagnostics.back": "Retour aux diagnostics",
    "diagnostics.copyReport": "Copier le rapport",
    "diagnostics.details": "Détails du diagnostic",
    "diagnostics.idPrefix": "ID de diagnostic",
    "diagnostics.loading": "Chargement du diagnostic...",
    "diagnostics.missingIdUrl": "ID de diagnostic manquant dans l’URL.",
    "diagnostics.noId": "Aucun ID de diagnostic",
    "diagnostics.notFound": "Diagnostic introuvable.",
    "diagnostics.view": "Voir le diagnostic",
    "filter.androidDiagnostic": "Diagnostic Android",
    "filter.applicationFilters": "Filtres des demandes d’inscription",
    "filter.deceased": "Décédé",
    "filter.diagnostic": "Diagnostic",
    "filter.diagnosticFilters": "Filtres de diagnostic",
    "filter.eventType": "Type d’événement",
    "filter.exclude": "Exclure",
    "filter.exclusionHelp": "Masqués par défaut. Inclure les affiche avec les autres. Uniquement les isole.",
    "filter.exclusions": "Exclusions",
    "filter.fatalCrash": "Crash fatal",
    "filter.female": "Femme",
    "filter.gender": "Sexe",
    "filter.age": "Âge",
    "filter.minimumAge": "Âge minimum",
    "filter.maximumAge": "Âge maximum",
    "filter.hasTabletId": "Avec ID de tablette",
    "filter.hide": "Masquer",
    "filter.include": "Inclure",
    "filter.male": "Homme",
    "filter.missingTabletId": "ID de tablette manquant",
    "filter.nfcInventory": "Inventaire NFC",
    "filter.noSexValues": "Aucune valeur de sexe.",
    "filter.noTagValues": "Aucune étiquette.",
    "filter.only": "Uniquement",
    "filter.operatorFilters": "Filtres des opérateurs",
    "filter.operatorRequestFilters": "Filtres des demandes opérateurs",
    "filter.personFilters": "Filtres des personnes",
    "filter.refineApplications": "Affiner les demandes d’inscription",
    "filter.refineDiagnostics": "Affiner les diagnostics",
    "filter.refineOperatorRequests": "Affiner les demandes opérateurs",
    "filter.refineOperators": "Affiner les opérateurs",
    "filter.refinePeople": "Affiner les personnes",
    "filter.refineVoters": "Affiner les électeurs",
    "filter.unresponsive": "Sans réponse",
    "filter.voterFilters": "Filtres des électeurs",
    "filter.votingCenterHide": "Masquer",
    "filter.votingCenterInclude": "Inclure",
    "filter.votingCenterOnly": "Uniquement",
    "filter.disabledCenters": "Centres désactivés",
    "filter.refineVotingCenters": "Affiner les centres de vote",
    "filter.availability": "Disponibilité",
    "filter.disabledCentersHelp": "Les centres désactivés sont masqués par défaut. Inclure les affiche avec les centres actifs. Uniquement n'affiche que les centres désactivés.",
    "filter.votingCenterReportFilters": "Filtres du rapport des centres de vote",
    "geo.addArrondissement": "Ajouter un arrondissement",
    "geo.addCommune": "Ajouter une commune",
    "geo.addConstituency": "Ajouter une circonscription",
    "geo.addDepartment": "Ajouter un département",
    "geo.addSection": "Ajouter une section",
    "geo.addVotingCenter": "Ajouter un centre de vote",
    "geo.arrondissement": "Arrondissement",
    "geo.capacity": "Capacité",
    "geo.communalSection": "Section communale",
    "geo.constituency": "Circonscription",
    "geo.item": "Élément",
    "geo.noVotingCentersSection": "Aucun centre de vote dans cette section.",
    "geo.subtitle": "Gérer la géographie électorale administrative et par circonscription.",
    "geo.tag": "Étiquette",
    "geo.tags.capacity50": "Alerte capacité 50 %",
    "geo.tags.capacity70": "Alerte capacité 70 %",
    "geo.tags.full": "Complet",
    "geo.title": "Géographie électorale",
    "geo.votingCenterGidRequired": "Le GID du centre de vote est requis pour la mise à jour.",
    "geo.votingCentersSelectedSection": "Centres de vote de la section sélectionnée",
    "menu.diagnostics.description": "Rapports de diagnostic des appareils de terrain",
    "menu.diagnostics.label": "Diagnostics",
    "menu.reporting.operators": "Rapports opérateurs",
    "menu.users.description": "Utilisateurs et rôles d’accès",
    "menu.users.label": "Utilisateurs",
    "menu.voter.registration.description": "Demandes d’inscription et registre électoral",
    "person.applicationSubmitted": "DEMANDE SOUMISE",
    "person.applications": "Demandes",
    "person.birthDate": "Date de naissance",
    "person.commune": "Commune",
    "person.contact": "contact",
    "person.contacts": "Contacts",
    "person.department": "Département",
    "person.firstName": "Prénom",
    "person.gid": "GID",
    "person.identity": "Identité",
    "person.lastName": "Nom",
    "person.nationalId": "Identifiant national",
    "person.nationalIdentifier": "Identifiant national",
    "person.noApplications": "Aucune demande.",
    "person.noContacts": "Aucun contact.",
    "person.noPhotos": "Aucune photo.",
    "person.noResidences": "Aucune résidence.",
    "person.noVoters": "Aucun électeur.",
    "person.notRegistered": "NON INSCRIT",
    "person.officeIdentifierNumber": "Numéro d’identification du bureau",
    "person.personGid": "GID de la personne",
    "person.photoAlt": "Photo de la personne",
    "person.photos": "Photos",
    "person.pictureAlt": "Photo de la personne",
    "person.recordNumber": "Numéro de dossier",
    "person.registered": "INSCRIT",
    "person.registrationDate": "Date d’inscription",
    "person.registrationStatus": "Statut d’inscription",
    "person.residence": "Résidence",
    "person.residences": "Résidences",
    "person.section": "Section",
    "person.sex": "Sexe",
    "person.unnamed": "Personne sans nom",
    "person.validFrom": "Valide à partir du",
    "person.validTo": "Valide jusqu’au",
    "person.viewPerson": "Voir la personne",
    "person.voters": "Électeurs",
    "reporting.accountsAttachedNinu": "Comptes rattachés à ce NINU",
    "reporting.activeCenters": "Centres actifs",
    "reporting.activeDays": "Jours actifs",
    "reporting.activeOperators": "Opérateurs actifs",
    "reporting.activitySpan": "Période d’activité",
    "reporting.advanced": "Avanse",
    "reporting.affectedVoters": "Électeurs concernés",
    "reporting.age18_28": "18 à 28",
    "reporting.age29_38": "29 à 38",
    "reporting.age39_48": "39 à 48",
    "reporting.age49_58": "49 à 58",
    "reporting.age59_68": "59 à 68",
    "reporting.age69plus": "69 ans et plus",
    "reporting.ageDistribution": "Répartition par âge",
    "reporting.allArrondissements": "Tous les arrondissements",
    "reporting.allCommunes": "Toutes les communes",
    "reporting.allConstituencies": "Toutes les circonscriptions",
    "reporting.allDepartments": "Tous les départements",
    "reporting.allSections": "Toutes les sections",
    "reporting.allVotingCenters": "Tous les centres de vote",
    "reporting.applicationMix": "Répartition des demandes",
    "reporting.applicationQuality": "Qualité des demandes",
    "reporting.applicationsLower": "demandes",
    "reporting.applicationsToRoll": "Des demandes à la liste actuelle",
    "reporting.applyFilters": "Appliquer les filtres",
    "reporting.assigned": "affecté",
    "reporting.assignedElsewhere": "Affecté ailleurs",
    "reporting.busiestDay": "Jour le plus actif",
    "reporting.cadenceHelp": "Chaque point représente une inscription à son heure réelle de soumission. Cliquez sur un point pour ouvrir le dossier.",
    "reporting.capacityUtilization": "Utilisation de la capacité",
    "reporting.capacityUtilizationByDepartment": "Utilisation de la capacité par département",
    "reporting.capacityUtilizationByDepartmentSubtitle": "Demandeurs en proportion de la capacité d’inscription configurée.",
    "reporting.captureChannel": "Canal de capture",
    "reporting.centerLocation": "Localisation du centre",
    "reporting.centerNotFound": "Centre de vote introuvable.",
    "reporting.centerRegistrationCapacity": "Inscriptions et capacité par centre de vote",
    "reporting.centersLower": "centres",
    "reporting.centersWithin75Km": "centres dans un rayon de 75 km",
    "reporting.clearHourFilter": "Effacer le filtre horaire",
    "reporting.clickCellInspect": "Cliquez sur une cellule pour examiner cette journée",
    "reporting.configured": "configurés",
    "reporting.configuredCenters": "Centres configurés",
    "reporting.correctionActivity": "Activité de correction",
    "reporting.correctionActivityDepartments": "Demandeurs ayant une demande de correction par département.",
    "reporting.correctionDemographics": "Démographie des demandeurs",
    "reporting.correctionDemographicsSubtitle": "Répartition par sexe et âge des demandeurs ayant une demande de correction.",
    "reporting.correctionHighlights": "Indicateurs clés des corrections",
    "reporting.correctionHighlightsSubtitle": "Indicateurs des demandeurs ayant une demande de correction dans le périmètre sélectionné.",
    "reporting.correctionReporting": "Rapports sur les corrections",
    "reporting.correctionRequests": "Demandes de correction",
    "reporting.correctionTimelineSubtitle": "Demandeurs ayant une demande de correction au fil du temps.",
    "reporting.corrections": "Corrections",
    "reporting.correctionsByCenter": "Demandes de correction par centre de vote",
    "reporting.correctionsByDepartment": "Demandes de correction par département",
    "reporting.correctionsCenterSubtitle": "Demandeurs ayant une demande de correction par centre de vote.",
    "reporting.correctionsLower": "corrections",
    "reporting.cumulativeFirstTimeApplicants": "nouveaux demandeurs cumulés",
    "reporting.currentElectoralRoll": "Liste électorale actuelle",
    "reporting.currentPollingStations": "Bureaux de vote actuels",
    "reporting.currentVoters": "Électeurs actuels",
    "reporting.dailyForensicView": "Analyse quotidienne détaillée",
    "reporting.dailyInspector": "Analyse quotidienne",
    "reporting.dailyRegistrationActivity": "Activité quotidienne d’inscription",
    "reporting.dateHourMatrix": "Matrice d’activité date × heure",
    "reporting.distinctApplicants": "Demandeurs distincts",
    "reporting.distinctVoters": "Électeurs distincts",
    "reporting.distributionDay": "Répartition dans la journée",
    "reporting.drillDown": "Détail",
    "reporting.duplicateRetransmission": "Doublon + retransmission",
    "reporting.duplicatesLower": "doublons",
    "reporting.exactSubmissionCadence": "Cadence exacte des soumissions",
    "reporting.firstApplicantsCapacity": "Nouveaux demandeurs par rapport à la capacité",
    "reporting.firstLower": "première",
    "reporting.firstRequest": "Première demande",
    "reporting.generalFilters": "Filtres généraux",
    "reporting.geoCorrections": "Répartition géographique des corrections",
    "reporting.geoDrilldownSubtitle": "Répartition et exploration des électeurs inscrits dans la géographie électorale.",
    "reporting.geoRegistrations": "Répartition géographique des électeurs inscrits",
    "reporting.geographicScope": "Périmètre géographique",
    "reporting.gis": "SIG",
    "reporting.gpsCapacityField": "Champ GPS de capacité",
    "reporting.high": "Élevé",
    "reporting.history": "Historique",
    "reporting.hourFilterHelp": "Demandeurs par heure pour cette date. Cliquez sur une heure pour filtrer les demandeurs ci-dessous.",
    "reporting.identityLinkage": "Rattachement d’identité",
    "reporting.kmAway": "km de distance",
    "reporting.lastActivity": "Dernière activité",
    "reporting.lastLower": "dernière",
    "reporting.lastApplication": "Dernière demande",
    "reporting.lastRegistration": "Dernière inscription",
    "reporting.lastRequest": "Dernière demande",
    "reporting.lifetimeHistory": "Historique complet",
    "reporting.loadingCenter": "Chargement du rapport du centre de vote…",
    "reporting.loadingDay": "Chargement de la journée…",
    "reporting.loadingEllipsis": "Chargement…",
    "reporting.loadingOperator": "Chargement du rapport opérateur…",
    "reporting.location": "Localisation",
    "reporting.locationFootprint": "Répartition géographique",
    "reporting.locationLower": "emplacement",
    "reporting.low": "Faible",
    "reporting.manual": "Manuel",
    "reporting.nearbyCapacity": "Capacité à proximité",
    "reporting.nearbyCapacityLegend": "Taille de la bulle = capacité du centre · couleur = utilisation par les demandeurs · losange = centre sélectionné",
    "reporting.nextDay": "Jour suivant",
    "reporting.ninuIdentities": "Identités NINU",
    "reporting.noActivityVisualize": "Aucune activité à visualiser.",
    "reporting.noCenter": "Aucun centre",
    "reporting.noData": "Aucune donnée de rapport",
    "reporting.noDataSelectedFilters": "Aucune donnée pour les filtres sélectionnés.",
    "reporting.noDaySelected": "Aucun jour sélectionné.",
    "reporting.noGpsCoordinatesForCenter": "Aucune coordonnée GPS n’est disponible pour ce centre.",
    "reporting.noOperators": "Aucun opérateur trouvé",
    "reporting.noRegistrationActivity": "Aucune activité d’inscription.",
    "reporting.noRegistrationHistory": "Aucun historique d’inscription.",
    "reporting.noRegistrationsDay": "Aucune inscription ce jour-là.",
    "reporting.noRegistrationsSelection": "Aucune inscription pour cette sélection.",
    "reporting.ofCapacity": "sur",
    "reporting.on": "le",
    "reporting.openMap": "Ouvrir la carte",
    "reporting.openRegistration": "Ouvrir l’inscription",
    "reporting.operatorActivityReport": "Rapport d’activité de l’opérateur",
    "reporting.operatorComposition": "Composition des opérateurs",
    "reporting.operatorNotFound": "Opérateur introuvable.",
    "reporting.operatorPerformance": "Performance des opérateurs",
    "reporting.operatorPerformanceSubtitle": "Demandeurs distincts traités par chaque opérateur, consolidés entre comptes selon le NINU de l’opérateur.",
    "reporting.operatorPlaceholder": "Nom, NINU ou nom d’utilisateur",
    "reporting.operatorReport": "Voir le rapport opérateur",
    "reporting.operators": "Opérateurs",
    "reporting.operatorsActiveHere": "opérateurs actifs ici",
    "reporting.operatorsLower": "opérateurs",
    "reporting.outcomeComposition": "Composition des résultats",
    "reporting.overCapacity": "Capacité dépassée",
    "reporting.overview": "Vue d’ensemble",
    "reporting.peak": "Pic",
    "reporting.perActiveDay": "Par jour actif",
    "reporting.plannedPollingStations": "Bureaux de vote prévus",
    "reporting.previousDay": "Jour précédent",
    "reporting.refresh": "Actualiser",
    "reporting.registeredVoters": "Électeurs inscrits",
    "reporting.registeredVotersLower": "électeurs inscrits",
    "reporting.registrationActivity": "Activité d’inscription",
    "reporting.registrationCadence": "Cadence des inscriptions",
    "reporting.registrationCatchment": "Zone de recrutement des inscriptions",
    "reporting.registrationCenterSubtitle": "Demandeurs, capacité configurée et utilisation par centre de vote.",
    "reporting.registrationHighlights": "Indicateurs clés des inscriptions",
    "reporting.registrationHighlightsSubtitle": "Indicateurs d’inscription pour le périmètre sélectionné.",
    "reporting.registrationProcess": "Processus d’inscription",
    "reporting.registrationStatuses": "Statuts des inscriptions",
    "reporting.registrationTimelineSubtitle": "Demandeurs au fil du temps.",
    "reporting.registrationType": "Type d’inscription",
    "reporting.registrations": "Inscriptions",
    "reporting.registrationsByCenter": "Inscriptions par centre de vote",
    "reporting.registrationsByDay": "Inscriptions par jour",
    "reporting.registrationsByDepartment": "Électeurs inscrits par département",
    "reporting.registrationsElsewhere": "inscriptions par des comptes affectés ailleurs",
    "reporting.registrationsLower": "inscriptions",
    "reporting.remaining": "Restant",
    "reporting.residenceGeography": "Géographie de résidence",
    "reporting.retransmissionsLower": "retransmissions",
    "reporting.scrollZoomHistoryHelp": "Faites défiler ou zoomez sur tout l’historique. Cliquez sur une barre pour examiner ce jour.",
    "reporting.selectDay": "Sélectionnez un jour",
    "reporting.selected": "Sélectionné",
    "reporting.selectedCenter": "Centre sélectionné",
    "reporting.sexDistribution": "Répartition par sexe",
    "reporting.sourceMix": "Répartition des sources",
    "reporting.standardActivityDepartments": "Électeurs inscrits par département.",
    "reporting.standardLower": "standard",
    "reporting.standardRegistration": "Rapports sur les inscriptions standard",
    "reporting.standardRegistrations": "Inscriptions standard",
    "reporting.statusProfile": "Profil des statuts",
    "reporting.submittedApplications": "Demandes soumises",
    "reporting.temporalFingerprint": "Empreinte temporelle",
    "reporting.totalCapacity": "capacité totale",
    "reporting.turnoutTrajectory": "Trajectoire de participation",
    "reporting.typeTwoChars": "Saisissez au moins deux caractères",
    "reporting.under18": "Moins de 18 ans",
    "reporting.uniqueApplicantNinus": "NINU uniques des demandeurs",
    "reporting.uniqueApplicants": "Demandeurs uniques",
    "reporting.uniqueNinus": "NINU uniques",
    "reporting.unknownCenter": "Centre inconnu",
    "reporting.unknownError": "Erreur de rapport inconnue",
    "reporting.unknownOperator": "Opérateur inconnu",
    "reporting.unknownResidenceSection": "Section de résidence inconnue",
    "reporting.unknownSection": "Section inconnue",
    "reporting.unnamedCenter": "Centre sans nom",
    "reporting.utilization": "Utilisation",
    "reporting.utilized": "utilisé",
    "reporting.viewCenterReport": "Voir le rapport du centre de vote",
    "reporting.views": "Vues des rapports",
    "reporting.voterDemographics": "Démographie des électeurs inscrits",
    "reporting.voterDemographicsSubtitle": "Répartition par sexe et âge des électeurs inscrits.",
    "reporting.votersLastStation": "Électeurs dans le dernier bureau",
    "reporting.votersLower": "électeurs",
    "reporting.votingCenterIntelligence": "Analyse du centre de vote",
    "reporting.votingCenterReports": "Rapports des centres de vote",
    "reporting.votingCenters": "Centres de vote",
    "reporting.workforce": "Effectifs",
    "user.account": "Compte",
    "user.accountRequest": "Demande de compte utilisateur",
    "user.accounts": "Comptes",
    "user.additionalGranularPermission": "autorisation granulaire supplémentaire",
    "user.additionalGranularPermissions": "autorisations granulaires supplémentaires",
    "user.apiKey": "Clé API",
    "user.apiKeyCopied": "Clé API copiée.",
    "user.apiKeyCurrentCannotBeViewed": "La clé API actuelle ne peut pas être affichée. La génération d’une nouvelle clé invalide immédiatement la clé précédente.",
    "user.apiUser": "Utilisateur API",
    "user.apiUserNotFound": "Utilisateur API introuvable.",
    "user.applicantSubtitle": "Identité et informations du compte demandé",
    "user.approvalRequest": "Demande d’approbation",
    "user.approvalRequestGid": "GID de la demande d’approbation",
    "user.approvalRequestSubtitle": "Demande source ayant créé ce compte",
    "user.approve": "Approuver",
    "user.assignedRoles": "Rôles attribués",
    "user.rolesAndPermissions": "Rôles et permissions",
    "user.selectFunctionalAccessGranular": "Sélectionnez un rôle pour accorder toutes ses permissions, ou développez-le pour choisir les permissions individuellement.",
    "user.savePermissions": "Enregistrer les permissions",
    "user.permissionAssignmentsSaved": "Permissions enregistrées.",
    "user.audit": "Audit",
    "user.backToApiUsers": "Retour aux utilisateurs API",
    "user.backToUsers": "Retour aux utilisateurs",
    "user.copyApiKeyNow": "Copiez cette clé maintenant. Elle ne sera plus affichée.",
    "user.createdAccount": "Compte créé",
    "user.createdAccountSubtitle": "Compte créé après approbation",
    "user.createdAt": "Créé le",
    "user.currentAccountStatus": "Statut actuel du compte",
    "user.decision": "Décision",
    "user.decisionReason": "Motif de la décision",
    "user.decisionSubtitle": "Métadonnées du résultat de l’examen",
    "user.decisionTime": "Date de décision",
    "user.fieldOperatorAccount": "Compte opérateur de terrain",
    "user.generateApiKey": "Générer une nouvelle clé API",
    "user.identitySubtitle": "Identité de l’opérateur et nom de connexion",
    "user.invalidQalaaUserId": "Identifiant utilisateur Qalaa invalide.",
    "user.lifecycleTimestamps": "Horodatages du cycle de vie",
    "user.newApiKey": "Nouvelle clé API",
    "user.newApiUser": "Nouvel utilisateur API",
    "user.openPersonRecord": "Ouvrir le dossier de la personne",
    "user.openRequest": "Ouvrir la demande",
    "user.profileCouldNotBeLoaded": "Le profil utilisateur n’a pas pu être chargé.",
    "user.qalaaId": "ID Qalaa",
    "user.qalaaUser": "Utilisateur Qalaa",
    "user.reject": "Rejeter",
    "user.requestGid": "GID de la demande",
    "user.requestStatus": "Statut de la demande",
    "user.roleAssignmentsCouldNotBeSaved": "Les attributions de rôles n’ont pas pu être enregistrées.",
    "user.roleAssignmentsSaved": "Attributions de rôles enregistrées.",
    "user.saveRoles": "Enregistrer les rôles",
    "user.selectFunctionalAccess": "Sélectionnez les accès fonctionnels requis pour cet utilisateur.",
    "user.synchronizationFailed": "Échec de la synchronisation.",
    "user.synchronize": "Synchroniser",
    "user.synchronizing": "Synchronisation...",
    "user.tagsSubtitle": "Indicateurs système associés à cette demande",
    "user.unableGenerateApiKey": "Impossible de générer la clé API.",
    "user.unableLoadApiUser": "Impossible de charger l’utilisateur API.",
    "user.unableSaveApiUser": "Impossible d’enregistrer l’utilisateur API.",
    "user.updatedAt": "Mis à jour le",
    "user.userAccount": "Compte utilisateur",
    "user.userNotFound": "Utilisateur introuvable.",
    "user.username": "Nom d’utilisateur",
    "user.viewAccount": "Voir le compte",
    "user.viewApiUser": "Voir l’utilisateur API",
    "user.viewApprovalRequest": "Voir la demande d’approbation",
    "user.viewProfile": "Voir le profil",
    "user.viewVotingCenter": "Voir le centre de vote",
    "user.votingCenterRequestSubtitle": "Affectation d’opérateur demandée lors de l’inscription",
    "user.votingCenterSubtitle": "Affectation de l’opérateur de terrain",
    "user.willBePreserved": "seront conservées.",
    "voter.applicant": "Demandeur",
    "voter.applicantNinu": "NINU du demandeur",
    "voter.applicantSnapshot": "Données du demandeur",
    "voter.application": "Demande d’inscription électorale",
    "voter.application.subtitle": "Dossier d’examen de la demande",
    "voter.applicationMetadataSubtitle": "Reçu, source, chronologie et métadonnées d’examen",
    "voter.applicationPhoto": "Photo de la demande",
    "voter.attempts": "Tentatives",
    "voter.lastAttempt": "Dernière tentative",
    "voter.primaryApplication": "Demande principale",
    "voter.rejectedAt": "Rejetée",
    "voter.archivedAt": "Archivée",
    "voter.applicationPhotoAlt": "Portrait de la demande électorale",
    "voter.applicationType": "Type de demande",
    "voter.applicationsLinked": "Demandes d’inscription liées à cette personne",
    "voter.assignedVotingLocation": "Lieu de vote attribué",
    "voter.birthDate": "Date de naissance",
    "voter.checked": "Vérifiée",
    "voter.correction": "Correction",
    "voter.correctionApplication": "Demande de correction",
    "voter.duplicate": "Doublon",
    "voter.gpsCoordinates": "Coordonnées GPS",
    "voter.gpsSubtitle": "Lieu où la demande a été soumise",
    "voter.gpsUnavailable": "Coordonnées GPS indisponibles",
    "voter.identitySnapshotSubtitle": "Données d’identité soumises avec cette demande",
    "voter.manualAdjudication": "Examen manuel",
    "voter.manualEntry": "Saisie manuelle",
    "voter.mrzNfc": "MRZ NFC",
    "voter.mrzSlashNfc": "MRZ / NFC",
    "voter.ninu": "NINU",
    "voter.noPhoto": "Aucune photo",
    "voter.noPortrait": "Aucun portrait",
    "voter.oniPhoto": "Photo ONI",
    "voter.oniPhotoAlt": "Portrait ONI",
    "voter.oniSearch": "Recherche ONI",
    "voter.operator": "Opérateur",
    "voter.operatorUserGid": "GID utilisateur de l’opérateur",
    "voter.personResolved": "Personne identifiée",
    "voter.selfService": "Auto-inscription",
    "voter.personName": "Nom de la personne",
    "voter.receipt": "Reçu",
    "voter.receiptNumber": "Numéro de reçu",
    "voter.correctReceiptNumber": "Corriger le numéro de reçu",
    "voter.newReceiptNumber": "Nouveau numéro de reçu",
    "voter.saveCorrection": "Enregistrer la correction",
    "voter.correctionFailed": "Impossible d’enregistrer la correction",
    "voter.correctionJournal": "Journal des corrections",
    "voter.correctionJournalSubtitle": "Corrections apportées à cette demande d’inscription",
    "voter.noCorrections": "Aucune correction n’a été effectuée.",
    "voter.journal.receiptNumberCorrected": "Numéro de reçu corrigé",
    "voter.oldValue": "Ancienne valeur",
    "voter.newValue": "Nouvelle valeur",
    "voter.correctedBy": "Corrigé par",
    "voter.record": "Dossier électoral",
    "voter.record.subtitle": "Affectation de l’électeur inscrit",
    "voter.registeredCitizenIdentity": "Identité du citoyen inscrit",
    "voter.requestedVotingLocation": "Lieu de vote demandé",
    "voter.retransmission": "Retransmission",
    "voter.reviewedAt": "Examiné le",
    "voter.reviewer": "Réviseur",
    "voter.reviewerUserGid": "GID utilisateur du réviseur",
    "voter.standard": "Standard",
    "voter.statusCode": "Code de statut",
    "voter.submittedAt": "Soumis le",
    "voter.usersInvolved": "Utilisateurs impliqués dans la soumission et l’examen",
    "voter.viewApplication": "Voir la demande",
    "voter.viewVoterRecord": "Voir le dossier électoral",
    "voter.voter": "Électeur",
    "voter.votingCenter": "Centre de vote",
    "voter.votingCenterGid": "GID du centre de vote",
    "voter.votingCenterId": "ID du centre de vote",
    "en-US": "Anglais",
    "fr-FR": "Français",
    "ht-HT": "Haïtien",
    "reporting.currentConfiguration": "Current configuration; not date-filtered",
    "reporting.invalidDateRange": "The start date must be on or before the end date.",
    "reporting.matchingApplications": "Applications matching the filters",
    "reporting.noMatchingApplications": "No applications submitted in this period.",
    "reporting.applicationGeography": "Geographic distribution of applications",
    "reporting.applicationsByDepartment": "Applications by department",
    "reporting.applicationsByDepartmentSubtitle": "Applications submitted by department during the selected period.",
    "reporting.rowsPerPage": "Rows per page",
    "reporting.applicants": "Demandeurs",
    "reporting.applicantsLower": "demandeurs",
    "reporting.applicantsByDay": "Demandeurs par jour",
    "reporting.applicantsByCenter": "Demandeurs par centre de vote",
    "reporting.applicantCadence": "Cadence des demandeurs",
    "reporting.noApplicantActivity": "Aucune activité de demandeurs.",
    "reporting.noApplicantsDay": "Aucun demandeur pour cette journée.",
    "reporting.noApplicantHistory": "Aucun historique de demandeurs.",
    "reporting.applicantCapacity": "Capacité et demandeurs",
    "reporting.applicantsElsewhere": "demandeurs affectés ailleurs",
    "reporting.applicantCatchment": "Zone de provenance des demandeurs",
    "reporting.dailyApplicantActivity": "Activité quotidienne des demandeurs",
    "reporting.noApplicantsSelection": "Aucun demandeur pour cette sélection.",
    "reporting.pendingApplications": "Demandes en cours de traitement",
    "Loading metadata": "Chargement des métadonnées",
    "role.systemAdministrator": "Administrateur système",
    "role.systemAdministrator.description": "Accès complet à toutes les fonctions sécurisées.",
    "role.userAdministration": "Administration des utilisateurs",
    "role.userAdministration.description": "Gérer les utilisateurs et leurs autorisations.",
    "role.statisticalReports": "Rapports statistiques",
    "role.statisticalReports.description": "Consulter les rapports statistiques, démographiques et géographiques.",
    "role.operationalReports": "Rapports opérationnels",
    "role.operationalReports.description": "Consulter les rapports opérationnels des opérateurs et des centres de vote.",
    "role.operatorManagement": "Gestion des opérateurs",
    "role.operatorManagement.description": "Examiner les demandes des opérateurs de terrain et gérer leurs comptes.",
    "role.voterRegistrationManagement": "Gestion de l’inscription des électeurs",
    "role.voterRegistrationManagement.description": "Gérer les électeurs, les demandes et les informations d’identité associées.",
    "role.electoralGeographyManagement": "Gestion de la géographie électorale",
    "role.electoralGeographyManagement.description": "Gérer la géographie électorale et les centres de vote.",
    "role.diagnosticsManagement": "Gestion des diagnostics",
    "role.diagnosticsManagement.description": "Consulter et gérer les rapports de diagnostic des appareils de terrain.",
    "reporting.exportExcel": "Exporter vers Excel",
    "reporting.exportingExcel": "Export en cours...",
    "reporting.exportFailed": "Impossible d’exporter les statistiques des centres de vote.",
    "voterRoll.preliminaryRolls": "Listes électorales préliminaires",
    "voterRoll.preliminaryRolls.description": "Créer, consulter et amender les listes électorales préliminaires.",
    "voterRoll.finalRolls": "Listes électorales définitives",
    "voterRoll.finalRolls.description": "Consulter et imprimer les listes électorales définitives.",
    "voterRoll.preliminary": "Liste électorale préliminaire",
    "voterRoll.final": "Liste électorale définitive",
    "voterRoll.roll": "Liste électorale",
    "voterRoll.event": "Événement électoral",
    "voterRoll.eventDate": "Date de l’événement",
    "voterRoll.cutoff": "Date limite des demandes",
    "voterRoll.createdAt": "Créée le",
    "voterRoll.closedAt": "Clôturée le",
    "voterRoll.entries": "Électeurs",
    "voterRoll.amendments": "Amendements",
    "voterRoll.sourceRoll": "Liste source",
    "voterRoll.viewRoll": "Voir la liste",
    "voterRoll.notFound": "Liste électorale introuvable.",
    "voterRoll.typeMismatch": "Le type de liste électorale ne correspond pas à cette page.",
    "voterRoll.preview": "Aperçu de la liste électorale",
    "voterRoll.livePreview": "Aperçu de la liste électorale actuelle",
    "voterRoll.loadingPreview": "Chargement de l’aperçu de la liste électorale...",
    "voterRoll.registeredVoters": "électeurs inscrits",
    "voterRoll.pollingStations": "bureaux de vote",
    "voterRoll.pollingStation": "Bureau de vote",
    "voterRoll.votersLower": "électeurs",
    "voterRoll.printBooklet": "Imprimer le livret",
    "voterRoll.preparingBooklet": "Préparation du livret…",
    "voterRoll.openingPrintDialog": "Ouverture de la fenêtre d’impression…",
    "voterRoll.previewLiveNotice": "Cet aperçu reflète le registre électoral actuel. Il peut encore changer jusqu’à la création de la liste électorale préliminaire.",
    "voterRoll.agencyName": "Conseil électoral provisoire",
    "voterRoll.bookletTitle": "Liste électorale",
    "voterRoll.livePreviewType": "APERÇU - DONNÉES ACTUELLES",
    "voterRoll.number": "N°",
    "voterRoll.photo": "Photo",
    "voterRoll.familyName": "Nom",
    "voterRoll.firstName": "Prénom",
    "voterRoll.dateOfBirth": "Date de naissance",
    "voterRoll.sex": "Sexe",
    "voterRoll.status.queued": "En attente",
    "voterRoll.status.generating": "Génération en cours",
    "voterRoll.status.open": "Ouverte",
    "voterRoll.status.closed": "Clôturée",
    "voterRoll.status.failed": "Échec",
    "voterRoll.status.ready": "Prête",
    "menu.reporting.tablets": "Rapport des tablettes",
    "filter.tabletFilters": "Filtres des tablettes",
    "filter.refineTablets": "Affiner le parc de tablettes",
    "reporting.tablet": "Tablette",
    "reporting.tabletVrApplication": "Application VR",
    "reporting.tabletBattery": "Batterie",
    "reporting.tabletLastContact": "Dernier contact",
    "reporting.tabletContactMdm": "MDM",
    "reporting.tabletContactBackend": "Serveur VR",
    "reporting.tabletRequiredVersion": "Version requise",
    "reporting.tabletCurrent": "À jour",
    "reporting.tabletOperational": "Opérationnelle",
    "reporting.tabletCondition": "État",
    "reporting.tabletAssignment": "Affectation",
    "reporting.tabletIncludeUnassigned": "Inclure les tablettes non affectées à un opérateur",
    "reporting.tabletNoOperator": "Non affectée",
    "reporting.tabletStale": "Aucun contact avec le MDM ou le serveur VR depuis plus de 24 heures",
    "reporting.tabletOutdated": "Application VR obsolète",
    "reporting.tabletAppMissing": "Application VR absente",
    "reporting.tabletStaleShort": "Aucun contact récent",
    "reporting.tabletOutdatedShort": "Application obsolète",
    "reporting.tabletAppMissingShort": "Application absente",
  "common.ok": "OK",
  "geo.mergeCenters": "Merge voting centers",
  "geo.closeAndRedirect": "Disable and redirect",
  "geo.sourceCenter": "Center to disable",
  "geo.destinationCenter": "Center to keep / destination",
  "geo.searchCenter": "Search by name or code",
  "geo.swapCenters": "Swap which center survives",
  "geo.votersToMove": "voters awaiting hourly reassignment",
  "geo.applicationsToMove": "applications referencing this center",
  "geo.redirectConfirmation": "The source center will be disabled and the destination recorded. An hourly job will reassign existing voters. Applications still referencing this center will resolve the destination before approval creates a voter. Published rolls are not changed.",
  "geo.redirectNextSteps": "No records are transferred during this operation.",
  "geo.confirmMerge": "Confirm merge",
  "geo.confirmClosure": "Confirm closure and redirection",
  "geo.redirectedTo": "Redirected to",
  "geo.redirectCompleted": "Redirection completed",
  "geo.unableToDisableVotingCenter": "Impossible de désactiver le centre de vote",
  "geo.votingCenterCannotBeDisabled": "Ce centre de vote ne peut pas être désactivé car des électeurs et des demandes d’inscription électorale lui sont associés.",
  "geo.votingCenterCannotDisableVotersAndApplications": "Ce centre de vote ne peut pas être désactivé car des électeurs et des demandes d’inscription électorale lui sont associés.",
  "geo.votingCenterCannotDisableVoters": "Ce centre de vote ne peut pas être désactivé car des électeurs lui sont associés.",
  "geo.votingCenterCannotDisableApplications": "Ce centre de vote ne peut pas être désactivé car des demandes d’inscription électorale lui sont associées.",
  "geo.votingCenterCannotDisableNotEmpty": "Ce centre de vote ne peut pas être désactivé car il n’est pas vide.",
  "common.enabled": "Activé",

  // API developer documentation
  "app.menu.developer.label": "Développeur",
  "app.menu.developer.apiDocumentation": "Documentation API",
  "developer.apiDocs.title": "Documentation API",
  "developer.apiDocs.developerDocumentation": "Documentation développeur",
  "developer.apiDocs.guide": "Guide",
  "developer.apiDocs.reference": "Référence",
  "developer.apiDocs.searchEndpoints": "Rechercher des points de terminaison",
  "developer.apiDocs.noEndpointsMatch": "Aucun point de terminaison ne correspond à la recherche.",
  "developer.apiDocs.accessDenied": "Accès à la documentation API refusé",
  "developer.apiDocs.pageRequires": "Cette page requiert",
  "developer.apiDocs.documentationGuide": "Guide de documentation",
  "developer.apiDocs.description": "Description",
  "developer.apiDocs.usage": "Utilisation",
  "developer.apiDocs.request": "Requête",
  "developer.apiDocs.pathParameters": "Paramètres de chemin",
  "developer.apiDocs.queryParameters": "Paramètres de requête",
  "developer.apiDocs.unresolvedParameters": "Paramètres non résolus",
  "developer.apiDocs.body": "Corps",
  "developer.apiDocs.mode": "Mode",
  "developer.apiDocs.noRequestBody": "Aucun corps de requête.",
  "developer.apiDocs.response": "Réponse",
  "developer.apiDocs.notes": "Notes",
  "developer.apiDocs.tryIt": "Essayer",
  "developer.apiDocs.name": "Nom",
  "developer.apiDocs.type": "Type",
  "developer.apiDocs.values": "Valeurs",
  "developer.apiDocs.default": "Valeur par défaut",
  "developer.apiDocs.item": "élément",
  "developer.apiDocs.nullable": "nullable",
  "developer.apiDocs.unique": "unique",
  "developer.apiDocs.predicate": "Prédicat",
  "developer.apiDocs.permission": "Permission",
  "developer.apiDocs.requiresPermission": "Requiert {permission}",
  "developer.apiDocs.predicateProtected": "L’exécution est protégée par le prédicat {predicate} ; l’appartenance aux permissions ne permet pas à elle seule de la préautoriser.",
  "developer.apiDocs.unspecifiedPolicy": "Le point de terminaison n’a pas de politique d’exécution explicite.",
  "developer.apiDocs.headers": "En-têtes",
  "developer.apiDocs.empty": "(vide)",
  "developer.apiDocs.execute": "Exécuter",
  "developer.apiDocs.executing": "Exécution…",
  "developer.apiDocs.copyCurl": "Copier cURL",
  "developer.apiDocs.sessionNote": "L’exécution dans le navigateur utilise la session actuelle. Le cURL copié n’inclut pas les informations d’authentification de la session du navigateur.",
  "developer.apiDocs.emptyServiceUri": "getServiceUri() a renvoyé une URI de service vide",
  "developer.apiDocs.mustBeJsonObject": "{name} doit être un objet JSON",
  "developer.apiDocs.unboundParameters": "Ce point de terminaison contient des paramètres sans liaison HTTP dans le contrat REST généré.",
  "developer.apiDocs.multipleBodies": "Ce point de terminaison déclare plusieurs corps de requête et ne peut pas être représenté par une seule requête HTTP brute.",
  "developer.apiDocs.methodBodyUnsupported": "Une requête {method} avec un corps ne peut pas être exécutée par l’API Fetch du navigateur.",
  "developer.apiDocs.pathParameterRequired": "Le paramètre de chemin {name} est obligatoire",
  "developer.apiDocs.unresolvedPathVariable": "Une variable de chemin non résolue subsiste dans {path}",

  "voter_application.onichecked_status": "Contrôle ONI effectué",
  "voter_application.face_verification_mismatch_status": "Échec de la vérification faciale"
};
